import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossierHistorical/${dossierId}/purchaseWithVehicle`, method: 'GET', token: token })
}
